import React, { ReactNode } from 'react';
import { Portal } from '../../components/Portal/component';
import {
  InstitutionSettingsContainer,
  SettingsContentContainer,
  SectionHeader,
} from './styles';
import { ConnectedInstitutionSettingsNav } from '../InstitutionSettings/Nav/connector';
import { TeamPage } from './TeamPage/components';
import { Payload } from '../../../ReduxStorage/location/states';
import { LearnersPage } from './LearnersPage/components';

export interface InstitutionAdminSettingsProps {
  locationPayload: Payload;
}

export const InstitutionAdminSettings: React.FC<InstitutionAdminSettingsProps> = ({
  locationPayload,
}) => {
  const { sectionId } = locationPayload;
  let sectionTitle = '';
  let InstitutionSettingsContent: ReactNode = <></>;

  switch (sectionId) {
    case 'team':
      sectionTitle = 'Team';
      InstitutionSettingsContent = <TeamPage />;
      break;
    case 'learners':
      sectionTitle = 'Learners';
      InstitutionSettingsContent = <LearnersPage />;
      break;
    default:
      // Default case showing dashboard section
      InstitutionSettingsContent = `${sectionId} route is not found`;
  }

  return (
    <Portal id="institution-settings-mount">
      <InstitutionSettingsContainer>
        <ConnectedInstitutionSettingsNav />
        <SettingsContentContainer>
          <SectionHeader>{sectionTitle}</SectionHeader>
          {InstitutionSettingsContent}
        </SettingsContentContainer>
      </InstitutionSettingsContainer>
    </Portal>
  );
};
